export default "__VITE_ASSET__DriHo_Si__"